// Symbol Search routes
export default [
  {
    path: 'symbol-search',
    name: 'symbolSearch',
    redirect: 'symbol-search/index',
    component: () =>
      import(
        /* webpackChunkName: "symbolSearch" */ '../views/symbolSearch/SymbolSearch.vue'
      ),
    children: [
      {
        path: 'index',
        name: 'symbolSearchIndex',
        meta: {
          tabbable: true,
          tableKeys: [],
          filterKeys: [],
          formKeys: [],
          routePermissions: ['symbolSearchManage'],
        },
        component: () =>
          import(
            /* webpackChunkName: "symbolSearchIndex" */ '../views/symbolSearch/SymbolSearchIndex.vue'
          ),
      },
    ],
  },
];
